import { render, staticRenderFns } from "./DashboardCoordenador.vue?vue&type=template&id=ecf8e4f8"
import script from "./DashboardCoordenador.vue?vue&type=script&lang=js"
export * from "./DashboardCoordenador.vue?vue&type=script&lang=js"
import style0 from "./DashboardCoordenador.vue?vue&type=style&index=0&id=ecf8e4f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports